export default {
  namespaced: true,
  strict: true,

  state: {
    opened: false,
    subtitle: '',
    other: false
  },

  getters: {
    opened: state => state.opened,
    subtitle: state => state.subtitle,
    other: state => state.other,
  },

  mutations: {
    SET_OPENED: (state, payload = null) => {
      state.opened = payload;
    },
    SET_SUBTITLE: (state, payload = null) => {
      state.subtitle = payload;
    },
    OTHER: (state) => {
      state.other = !state.other;
    }
  },
};